export default "__VITE_ASSET__c417035f__"